import { render } from "./specificCar.vue?vue&type=template&id=618848f5"
import script from "./specificCar.vue?vue&type=script&lang=js"
export * from "./specificCar.vue?vue&type=script&lang=js"

import "./specificCar.vue?vue&type=style&index=0&id=618848f5&lang=scss"

import exportComponent from "D:\\A-wy-work\\wy-vue-source\\wy-saas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__